// ================================================================
// Bexio Node — Configuration Schema
// ================================================================
// فیلدهای modal تنظیمات Bexio — می‌تونی هر چقدر بخوای گسترش بدی.

export const bexioConfigSchema = {
  fields: [
    // ───────────────────────────────────────────
    // 1) نوع عملیات Bexio
    // ───────────────────────────────────────────
    {
      key: 'action',
      type: 'select',
      labelKey: 'nodes.bexio.fields.action',
      placeholderKey: 'nodes.bexio.placeholders.action',
      required: true,
      options: [
        { value: 'createContact',  labelKey: 'nodes.bexio.options.createContact' },
        { value: 'createInvoice',  labelKey: 'nodes.bexio.options.createInvoice' },
        { value: 'getContact',     labelKey: 'nodes.bexio.options.getContact' },
        { value: 'listInvoices',   labelKey: 'nodes.bexio.options.listInvoices' }
      ]
    }

    // در آینده می‌تونی فیلدهای شرطی اضافه کنی
    // مثلاً برای createInvoice، یه فیلد بیاد که contactId رو بپرسه:
    //
    // {
    //   key: 'contactId',
    //   type: 'text',
    //   labelKey: 'nodes.bexio.fields.contactId',
    //   required: true,
    //   showIf: { action: 'createInvoice' }
    // }
  ]
};
